import { render } from "./LandingPage.vue?vue&type=template&id=7d23f702&scoped=true"
import script from "./LandingPage.vue?vue&type=script&lang=js"
export * from "./LandingPage.vue?vue&type=script&lang=js"

import "./LandingPage.vue?vue&type=style&index=0&id=7d23f702&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7d23f702"

export default script